import React from "react";
import { FormattedMessage } from '../../../../util/reactIntl';


import css from './SectionFaq.module.css';
import { CollapseFAQ, H2, H3, NamedLink } from "../../../../components";
import { searchTypes } from "../../../../util/searchHelpers";

const dogsLink = (
    <NamedLink
        name="PetSittingServicesPage"
        params={{ serviceType: 'dog-sitting' }}
    >
        <FormattedMessage id="SectionFaq.sittingQ2DogsLink" />
    </NamedLink>
);

const catsLink = (
    <NamedLink
        name="PetSittingServicesPage"
        params={{ serviceType: 'cat-sitting' }}
    >
        <FormattedMessage id="SectionFaq.sittingQCatsLink" />
    </NamedLink>
);

const birdsLink = (
    <NamedLink
        name="PetSittingServicesPage"
        params={{ serviceType: 'bird-sitting' }}
    >
        <FormattedMessage id="SectionFaq.sittingQBirdsLink" />
    </NamedLink>
);

const faqsSitter = [
    {
        question: <FormattedMessage id="SectionFaq.sitterQ1Label" />,
        answer: <FormattedMessage id="SectionFaq.sitterQ1Answer" />,
    },
    {
        question: <FormattedMessage id="SectionFaq.sitterQ2Label" />,
        answer: <FormattedMessage id="SectionFaq.sitterQ2Answer" />,
    },
    {
        question: <FormattedMessage id="SectionFaq.sitterQ3Label" />,
        answer: <FormattedMessage id="SectionFaq.sitterQ3Answer" />,
    },
    {
        question: <FormattedMessage id="SectionFaq.sitterQ4Label" />,
        answer: <FormattedMessage id="SectionFaq.sitterQ4Answer" />,
    },
];

const faqsSitting = [
    {
        question: <FormattedMessage id="SectionFaq.sittingQ1Label" />,
        answer: <FormattedMessage id="SectionFaq.sittingQ1Answer" />,
    },
    {
        question: <FormattedMessage id="SectionFaq.sittingQ2Label" />,
        answer: <FormattedMessage id="SectionFaq.sittingQ2Answer" values={{ dogsLink, catsLink, birdsLink }} />,
    },
    {
        question: <FormattedMessage id="SectionFaq.sittingQ3Label" />,
        answer: <FormattedMessage id="SectionFaq.sittingQ3Answer" />,
    },
    {
        question: <FormattedMessage id="SectionFaq.sittingQ4Label" />,
        answer: <FormattedMessage id="SectionFaq.sittingQ4Answer" />,
    },
]


const SectionFaq = props => {

    const { searchType } = props;

    // const membershipPlans = <NamedLink
    //     name="MembershipPlansPage"
    // >
    //     <FormattedMessage id="SectionFaq.membershipPlans" />
    // </NamedLink>
    return (
        <div className={css.root}>
            <H2 className={css.mainTitle}>
                {searchType === searchTypes.houseSitter ?
                    <FormattedMessage id="SectionFaq.mainTitle1" />
                    :
                    <FormattedMessage id="SectionFaq.mainTitle2" />
                }

                {/* <p className={css.info}>
                    <FormattedMessage id="SectionFaq.info" />
                    </p> */}
            </H2>

            <div className={css.container}>
                <CollapseFAQ
                    list={searchType === searchTypes.houseSitter ? faqsSitter : faqsSitting}
                />
            </div>

            {/* <div className={css.container}>
                <div className={css.card}>
                    <H3 className={css.title}>
                        <FormattedMessage id="SectionFaq.card1.title" />
                    </H3>
                    <p>
                        <FormattedMessage id="SectionFaq.card1.text" values={{ plans: membershipPlans }} />
                    </p>
                </div>
                <div className={css.card}>
                    <H3 className={css.title}>
                        <FormattedMessage id="SectionFaq.card2.title" />
                    </H3>
                    <ol>
                        <FormattedMessage id="SectionFaq.card2.text" />
                        <li><FormattedMessage id="SectionFaq.card2.listItem1" /></li>
                        <li><FormattedMessage id="SectionFaq.card2.listItem2" /></li>
                        <li><FormattedMessage id="SectionFaq.card2.listItem3" /></li>
                    </ol>
                </div>
                <div className={css.card}>
                    <H3 className={css.title}>
                        <FormattedMessage id="SectionFaq.card3.title" />
                    </H3>
                    <p>
                        <FormattedMessage id="SectionFaq.card3.text" />
                    </p>
                </div>

            </div>
            <span>
                <FormattedMessage id="SectionFaq.see" />
                <a>
                    <FormattedMessage id="SectionFaq.link" />
                </a>
            </span> */}
        </div>
    );
};

export default SectionFaq;